import React, { useRef, useState } from 'react';
import { Button } from '../../campaign-os';
import { useShellToast } from '../useShellToast';
import { campaignService, getErrorMessage } from '../../../../services/apiService';

/**
 * "Upload Excel" wherever vendors are picked: a sheet with a Vendor Code column is sent to the
 * audience import (which only reads), every code is matched to a vendor, and the caller gets the
 * matched rows plus the codes that matched nothing — so a lot list from finance becomes a
 * selection in one click, and nobody types codes by hand.
 */
export function VendorSheetUpload({ onResolved, label = 'Upload Excel', variant = 'secondary', size = 'sm', disabled = false }) {
  const ref = useRef(null);
  const toast = useShellToast();
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setBusy(true);
    try {
      const res = await campaignService.importAudience(file);
      const d = res?.data || {};
      onResolved({
        file: file.name,
        matched: d.matched || [],
        missing: d.missing || [],
        total_codes: d.total_codes ?? (d.matched || []).length,
        header_matched: !!d.header_matched,
        duplicates: d.duplicates || [],
      });
    } catch (err) {
      toast(getErrorMessage(err) || 'Could not read the sheet', { tone: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" className="hidden" onChange={onFile} aria-hidden="true" tabIndex={-1} />
      <Button
        variant={variant}
        size={size}
        icon={busy ? 'hourglass_top' : 'upload_file'}
        onClick={() => ref.current?.click()}
        disabled={busy || disabled}
        title='Any sheet with a vendor-code column — "Vendor Code", "Supplier Code" or just "Code", wherever it sits. Every code is matched to a vendor and ticked; codes that match nothing are listed.'
      >
        {busy ? 'Reading…' : label}
      </Button>
    </>
  );
}

export default VendorSheetUpload;
